import React, { useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { setIsUiHidden, setPublicProfView } from '../../../../store/entities/ui';
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from '../../../../components/reusable/LoadingSpinner';
import UnauthenticatedWrapper from '../../../Search/UnauthenticatedSearch/UnauthenticatedWrapper';
import { resetProfessionalReport } from '../../../../store/entities/professionalReport';
import { useParams } from 'react-router-dom';
import i18n from 'i18next';
import useRedirect from '../../../../hooks/navigation/useRedirect';
import { getPublicBasicData, getPublicPdf } from '../../../../store/entities/companySearchResult/thunks';
import { b64toBlob } from '../../../../utils/download';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { useTranslation } from 'react-i18next';
import { IdcardOutlined } from '@ant-design/icons';
import CompanyDataCard from '../../../../components/reusable/CompanyDataCard';

const PublicProfReport = () => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const dispatch = useDispatch();
  const { language, companyId } = useParams();
  const redirect = useRedirect();
  const { t } = useTranslation();
  const { basicDataPending, basicData, publicPdfPending } = useSelector(state => state.companySearchResult);

  useEffect(() => {
    i18n.changeLanguage(language);
    dispatch(setIsUiHidden(false));
    dispatch(setPublicProfView(true));
    dispatch(getPublicBasicData(companyId));

    return () => {
      dispatch(resetProfessionalReport());
      dispatch(setPublicProfView(false));
    };
  }, []);

  const getPdfReport = async () => {
    const pdfResult = await dispatch(getPublicPdf({ id: basicData?.id, languageCode: language }));
    if (getPublicPdf.fulfilled.match(pdfResult)) {
      const data = b64toBlob(pdfResult.payload.data);
      const url = URL.createObjectURL(data);
      setPdfUrl(url);
    }
  };

  useEffect(() => {
    if (!basicDataPending && basicData) {
      if (basicData?.availabilityType === 'Enabled') {
        getPdfReport();
      } else {
        localStorage.setItem(
          'publicProfDisabled',
          JSON.stringify({ companyCode: companyId, availabilityType: basicData?.availabilityType })
        );
        redirect(`/search/company/${companyId}/result`);
        setPdfUrl(null);
      }
    }
  }, [basicData]);

  return (
    <LoadingSpinner size="large" spinning={basicDataPending || publicPdfPending}>
      <UnauthenticatedWrapper>
        <CompanyDataCard
          icon={<IdcardOutlined className="icon--gray" />}
          title={basicData?.companyName}
          disclaimer={
            basicData?.companyCode
              ? `${t('foreignCompanySearch.results.basic.disclaimer')} - ${basicData?.companyCode}`
              : ''
          }
        >
          <Row className="professional-full-report interaction-disabling">
            <Col style={{ marginTop: 20, paddingLeft: 20, paddingRight: 20 }} span={24}>
              {pdfUrl ? (
                <div style={{ width: '100%', height: '90vh', minHeight: 600 }} className="space-top-md">
                  <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                    <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                  </Worker>
                </div>
              ) : null}
            </Col>
          </Row>
        </CompanyDataCard>
      </UnauthenticatedWrapper>
    </LoadingSpinner>
  );
};

export default PublicProfReport;
